import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 Advanced Technologies. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
